import { createSelector } from "reselect";
export var userSelector = function(state) {
    return state.userManagement;
};
export var getUserProfileInfoSelector = createSelector(userSelector, function(param) {
    var user = param.user;
    return user;
});
export var getInvitationStatus = createSelector(userSelector, function(param) {
    var invitationStatus = param.invitationStatus;
    return invitationStatus;
});
export var getUsersListSelector = createSelector(userSelector, function(param) {
    var usersList = param.usersList;
    return usersList;
});
export var getInvitationsListSelector = createSelector(userSelector, function(param) {
    var invitationsList = param.invitationsList;
    return invitationsList;
});
export var getUsersListErrorSelector = createSelector(userSelector, function(param) {
    var usersListError = param.usersListError;
    return usersListError;
});
export var getCreateInvitationSuccessSelector = createSelector(userSelector, function(param) {
    var createInvitationSuccess = param.createInvitationSuccess;
    return createInvitationSuccess;
});
export var getDeactivatedUsersSelector = createSelector(userSelector, function(param) {
    var deactivatedUsersList = param.deactivatedUsersList;
    return deactivatedUsersList;
});
export var getRequestedUserDetailsSelector = createSelector(userSelector, function(param) {
    var requestedUserProfileDetails = param.requestedUserProfileDetails;
    return requestedUserProfileDetails;
});

//# sourceMappingURL=selectors.js.map